module.exports = __webpack_public_path__ + "img/periodic_geo_in.fc5c4019.png";